import { useTheme } from "../context/ThemeContext";
import "../css/ThemeToggle.css";

type Props = {
  variant?: "inline" | "floating";
};

export default function ThemeToggle({ variant = "inline" }: Props) {
  const { theme, toggleTheme } = useTheme();
  const nextTheme = theme === "dark" ? "light" : "dark";

  return (
    <button
      type="button"
      className={`themeToggle themeToggle--${variant}`}
      onClick={toggleTheme}
      aria-label={`Switch to ${nextTheme} mode`}
      title={`Switch to ${nextTheme} mode`}
    >
      <span className={`themeToggle-track themeToggle-track--${theme}`} aria-hidden="true">
        <span className="themeToggle-thumb" />
      </span>
      <span className="themeToggle-text">{theme === "dark" ? "Night" : "Day"}</span>
    </button>
  );
}
